import { ref } from 'vue';

export default function useColumnManagement(storeParam) {
  const columnSettingsMenuOpen = ref(false);
  const draggedColumn = ref(null);

  // Column drag and drop
  const onDragStart = (column) => {
    draggedColumn.value = column;
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  const onDrop = (targetColumn) => {
    if (!draggedColumn.value || !storeParam) return;
    
    // Get the right columns array based on the store type
    const columns = storeParam.statusColumns || storeParam.columns;
    
    // Find indices in the appropriate array
    const sourceIndex = columns.findIndex(c => c.key === draggedColumn.value.key);
    const targetIndex = columns.findIndex(c => c.key === targetColumn.key);
    
    if (sourceIndex === -1 || targetIndex === -1 || sourceIndex === targetIndex) return;
    
    // Update column order
    const draggedItem = columns.splice(sourceIndex, 1)[0];
    columns.splice(targetIndex, 0, draggedItem);
    storeParam.salvarOrdemDasColunas();
    
    draggedColumn.value = null;
  };

  const toggleColumnVisibility = (column, index) => {
    if (!storeParam) return;
    
    // Get the right columns array based on the store type
    const columns = storeParam.statusColumns || storeParam.columns;
    
    // Toggle visibility and save
    if (columns[index]) {
      columns[index].visible = !columns[index].visible;
      storeParam.saveColumnVisibility();
    }
  };

  return {
    columnSettingsMenuOpen,
    draggedColumn,
    onDragStart,
    onDragOver,
    onDrop,
    toggleColumnVisibility
  };
}
